/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Reply_HintInputs */

const cs_messages_reply_hint = /** @type {(inputs: Messages_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud portál nepřijímá odpovědi, pošleme e-mail tazateli.`)
};

const en_messages_reply_hint = /** @type {(inputs: Messages_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the portal cannot accept replies, we e-mail the sender.`)
};

/**
* | output |
* | --- |
* | "If the portal cannot accept replies, we e-mail the sender." |
*
* @param {Messages_Reply_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_reply_hint = /** @type {((inputs?: Messages_Reply_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Reply_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_reply_hint(inputs)
	return cs_messages_reply_hint(inputs)
});